// extracted by mini-css-extract-plugin
export default {"space-list":"Planets_space-list__f9b9H"};